import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { WelcomeScreen } from './WelcomeScreen';
import { ChoosePathScreen } from './ChoosePathScreen';
import { TemplateCurationScreen } from './TemplateCurationScreen';
import { AIBuilderScreen } from './AIBuilderScreen';
import { OrientationScreen } from './OrientationScreen';
export function OnboardingFlow() {
  const [currentScreen, setCurrentScreen] = useState(1);
  const [direction, setDirection] = useState(1);
  const [selectedPath, setSelectedPath] = useState<'template' | 'ai' | 'scratch' | null>(null);
  const nextScreen = () => {
    setDirection(1);
    setCurrentScreen(prev => prev + 1);
  };
  const prevScreen = () => {
    setDirection(-1);
    setCurrentScreen(prev => prev - 1);
  };
  const goToScreen = (screen: number) => {
    setDirection(screen > currentScreen ? 1 : -1);
    setCurrentScreen(screen);
  };
  const handlePathSelection = (path: 'template' | 'ai' | 'scratch') => {
    setSelectedPath(path);
    if (path === 'template') {
      goToScreen(3); // Template curation
    } else if (path === 'ai') {
      goToScreen(4); // AI Builder
    } else {
      goToScreen(5); // Orientation (skip to end for scratch)
    }
  };
  // Calculate total screens based on path
  const getTotalScreens = () => {
    if (selectedPath === 'ai') return 5;
    if (selectedPath === 'template') return 5;
    return 5;
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 20 : -20,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 20 : -20,
      opacity: 0
    })
  };
  return <div className="bg-[#0f0f2d] min-h-screen w-full text-white font-sans selection:bg-[#ffc978]/30" data-id="element-99">
      {/* Progress Indicator */}
      <div className="fixed top-0 left-0 w-full h-1 bg-[#1a1a3e] z-50" data-id="element-100">
        <motion.div className="h-full bg-[#ffc978]" initial={{
        width: '0%'
      }} animate={{
        width: `${currentScreen / getTotalScreens() * 100}%`
      }} transition={{
        duration: 0.5
      }} data-id="element-101" />
      </div>

      <AnimatePresence mode="wait" custom={direction} data-id="element-102">
        {/* Screen 1: Welcome */}
        {currentScreen === 1 && <motion.div key="screen1" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.4
      }} className="w-full" data-id="element-103">
            <WelcomeScreen onNext={nextScreen} data-id="element-104" />
          </motion.div>}

        {/* Screen 2: Choose Path */}
        {currentScreen === 2 && <motion.div key="screen2" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.4
      }} className="w-full" data-id="element-105">
            <ChoosePathScreen onNext={handlePathSelection} onBack={prevScreen} data-id="element-106" />
          </motion.div>}

        {/* Screen 3: Template Curation (Template path) */}
        {currentScreen === 3 && <motion.div key="screen3" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.4
      }} className="w-full" data-id="element-107">
            <TemplateCurationScreen onNext={() => goToScreen(5)} onBack={() => goToScreen(2)} data-id="element-108" />
          </motion.div>}

        {/* Screen 4: AI Builder (AI path) */}
        {currentScreen === 4 && <motion.div key="screen4" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.4
      }} className="w-full" data-id="element-109">
            <AIBuilderScreen onNext={() => goToScreen(5)} onBack={() => goToScreen(2)} data-id="element-110" />
          </motion.div>}

        {/* Screen 5: Orientation (Final) */}
        {currentScreen === 5 && <motion.div key="screen5" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
        duration: 0.4
      }} className="w-full" data-id="element-111">
            <OrientationScreen onNext={() => alert('Flow Complete! Redirecting to editor...')} onBack={() => {
          if (selectedPath === 'template') goToScreen(3);else if (selectedPath === 'ai') goToScreen(4);else goToScreen(2);
        }} data-id="element-112" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}